<template>
  <div>
    <OpeningBalance v-if="!$route.params.type" />
    <OpeningBalanceType v-if="$route.params.type" />
  </div>
</template>
<script>
import store from "@/store/index";
import OpeningBalance from "@/components/Form/Settings/OpeningBalance/OpeningBalance";
import OpeningBalanceType from "@/components/Form/Settings/OpeningBalance/Type";
export default {
  components: {
    OpeningBalance,
    OpeningBalanceType,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (!routeTo.params.type) {
      store.dispatch("settings/fetchopeningbalancedetails").then(() => {
        next();
      });
    } else {
      store
        .dispatch("settings/fetchopeningbalancetypedetails", {
          type: routeTo.params.type,
          page: 1,
          show: 10,
        })
        .then(() => {
          next();
        });
    }
  },
};
</script>
